import { render } from "./searchForm.vue?vue&type=template&id=5a132a0c"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"

import "./searchForm.vue?vue&type=style&index=0&id=5a132a0c&lang=css"

import exportComponent from "/Users/wojtek/web/customer-zone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__